import React from "react";
import "./brand.scss";
import Comps from "components/brand";
const { AppBrand, QCode } = Comps;
const BrandPage = props => {
  return (
    <div className={`page-brand ${props.toTop?"brand-top":""} ${props.shown ? "shown" : ""}`}>
      {props.shown && <QCode alt="讯飞配音" />}
      <p className="brand-title">更多有声H5制作，尽在讯飞配音</p>
      <p className="hor-sperator"></p>
      {props.shown && <AppBrand style={{ marginTop: "68px" }}></AppBrand>}
    </div>
  );
};
export default BrandPage;
